import { Box, Typography } from '@mui/material';
import Logo from '/assets/logo/logo_moe.svg';
import { login } from '~/views/Login/Login.style';
import { pxToRem } from '~/theme/typography';
import { StyledButton } from './MoeEntrnace.style';
import { useGetMOELoginUrlQuery } from '~/api/MOELogin';

export const MoeEntrance = () => {
  const { data } = useGetMOELoginUrlQuery({
    clientid: import.meta.env.VITE_MOE_CLIENT_ID,
    params: '',
  });
  const MOEUrl = data?.data?.url;

  return (
    <Box>
      <login.title>教育雲端帳號</login.title>
      <login.subTitle>
        歡迎踴躍使用教育部提供的教育雲端帳號(OpenID)
      </login.subTitle>
      <StyledButton
        variant="outlined"
        disabled={!MOEUrl}
        onClick={() => window.open(MOEUrl, '_self')}
      >
        <img src={Logo} />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: pxToRem(18),
            color: '#346289',
          }}
        >
          使用教育雲端帳號登入
        </Typography>
      </StyledButton>
    </Box>
  );
};
